<template lang="html">
<div>
      <div class="subpage policies1">
            <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                <div class="text-block title-block clearfix">
                    <div class="bName">标题</div>
                    <div class="bContent">
                          <el-form-item style="width:100%;" prop="title">
                             <el-input class="inpText" size="medium" v-model="params.title" placeholder="请输入内容"></el-input>
                          </el-form-item>
                    </div>
                </div>

                <div class="selects">
                      <div class="select-line">

                          <div class="selectGp">
                                <span>政策分类</span>

                                <el-form-item prop="declarationOrPolicyClassificationId">
                                    <dic-select code="sbhzcfl"
                                         :selectId="params.declarationOrPolicyClassificationId"
                                         paramsKey="declarationOrPolicyClassification"
                                         @selectChange="selectChange"
                                         plaText="政策分类" />
                                </el-form-item>

                          </div>

                          <div class="selectGp">
                                <span>特定对象</span>
                                <el-form-item prop="specificObjectId">
                                    <all-select code="tddx"
                                         :selectId="params.specificObjectId"
                                         paramsKey="specificObject"
                                         @selectChange="allSelect"
                                         plaText="特定对象" />
                                </el-form-item>
                          </div>

                          <div class="selectGp">
                                <span>发布层级</span>
                                <el-form-item prop="releaseLevelId">
                                    <dic-select code="fbjb" :selectId="params.releaseLevelId" paramsKey="releaseLevel" plaText="发布层级" @selectChange="selectChange" />
                                </el-form-item>
                          </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>发文机构</span>
                              <el-form-item prop="publishingDepartmentNames">
                                  <el-input v-model="params.publishingDepartmentNames" placeholder="如有多个机构，请用 ‘，’ 隔开" size="medium"></el-input>
                              </el-form-item>

                        </div>

                        <div class="selectGp">
                              <span>发文字号</span>
                              <el-form-item prop="sendTextNumber">
                                  <el-input v-model="params.sendTextNumber" size="medium"></el-input>
                              </el-form-item>

                        </div>

                        <div class="selectGp">
                              <span>成文日期</span>
                              <el-form-item prop="writtenDate">
                                  <el-date-picker
                                   size="medium"
                                   align="right"
                                   type="date"
                                   value-format="yyyy-MM-dd"
                                   v-model="params.writtenDate"
                                   placeholder="选择日期">
                                 </el-date-picker>
                              </el-form-item>
                        </div>

                      </div>

                      <div class="select-line">

                        <div class="selectGp">
                              <span>主题分类</span>
                              <el-form-item prop="topicClassification">
                                  <el-input v-model="params.topicClassification" size="medium"></el-input>
                              </el-form-item>
                        </div>

                        <div class="selectGp">
                              <span>行业分类</span>
                              <el-form-item prop="industryId">
                                  <all-select code="szhy"
                                      :selectId="params.industryId"
                                      paramsKey="industry"
                                      @selectChange="allSelect"/>
                              </el-form-item>

                        </div>

                      </div>

                </div>
            </el-form>

            <div class="text-block img-block clearfix">
                <div class="bName">封面图</div>
                <div class="bContent">
                      <img-upload :image="params.image" @imgChange="imgChange" tips="（115*70推荐）" />
                </div>
            </div>

            <div class="enclosure">
                 <div class="ttl">附件</div>
                 <div class="ecContent">
                      <file-upload :files="params.fileId" @fileChange="fileChange" />
                 </div>
            </div>

            <div class="text-block poc-block clearfix">
                <div class="bName">相关政策</div>
                <div class="bContent">
                      <el-select
                        class="inpText"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="搜索政策、通知、解读"
                        :remote-method="pocSeek"
                        @change="pocSelect"
                        :loading="loading">
                        <el-option
                          v-for="item in pocList"
                          :key="item.id"
                          :label="item.title"
                          :value="item">
                        </el-option>
                      </el-select>
                </div>
            </div>

            <div class="pocRelative">
                <el-table
                    :data="selectedArr"
                    border>
                    <el-table-column
                      prop="title"
                      label="相关内容">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      width="180">

                         <template slot-scope="scope">
                             <el-button @click="selectRemove(scope.row)" size="small" type="danger" plain>删除</el-button>
                         </template>

                    </el-table-column>
                </el-table>
            </div>

      </div>
</div>
</template>

<script>
import { pocPredat, pocSeek, pocReltGet } from "@/api/policies/policies";
export default {
  data() {
    return {

      pocList: [],

      selectedArr: [],
      selectedMap: {},

      params: {

        title: '',
        declarationOrPolicyClassification: '',  // 政策分类
        declarationOrPolicyClassificationId: '',

        specificObject: '',  // 特定对象
        specificObjectId: '',

        releaseLevel: '',  // 发布级别
        releaseLevelId: '',

        publishingDepartmentIds: '',   // 发文机构
        publishingDepartmentNames: '',

        sendTextNumber: '',  //发文字号
        writtenDate: '', // 成文日期

        topicClassificationId: '',  // 主题分类
        topicClassification: '',

        industry: '',  // 行业分类
        industryId: '',

        image: '',  //  封面图
        fileId: '',  // 附件

      },

      rules: {
        title: [{
          required: true,
          trigger: 'blur'
        }],
        declarationOrPolicyClassificationId: [{
          required: true,
          trigger: 'change'
        }],
        specificObjectId: [{
          required: true,
          trigger: 'change'
        }],
        releaseLevelId: [{
          required: true,
          trigger: 'change'
        }],
        industryId: [{
          required: true,
          trigger: 'change'
        }],
        publishingDepartmentNames: [{
          required: true,
          trigger: 'change'
        }],
        sendTextNumber: [{
          required: true,
          trigger: 'change'
        }],
        writtenDate: [{
          required: true,
          trigger: 'change'
        }],
        topicClassification: [{
          required: true,
          trigger: 'blur'
        }],
      }
    }
  },
  methods: {
    selectChange: function (e) {   //  单选
      this.params[e.paramsKey] = e.name;
      this.params[e.paramsKey + 'Id'] = e.id;
    },
    allSelect: function (e) {     //  复选
      this.params[e.paramsKey] = e.name;
      this.params[e.paramsKey + 'Id'] = e.id;
    },
    fileChange: function (e) {    //  附件
      if (e.length > 0) {
        this.params.fileId = JSON.stringify(e);
      } else {
        this.params.fileId = '';
      }

    },
    imgChange: function (e) {     //  封面图
      this.params.image = e;
    },
    pocSeek: function (query) {     //  相关政策查询
      var vues = this;
      pocSeek({
        keyword: query || '',
        type: 1,
        size: 500,
        no: 1
      }).then(res => {
        vues.pocList = res.relatedPolicyList;
      })
    },
    pocSelect: function (e) {
      if (!this.selectedMap[e.relatedId]) {
        this.selectedMap[e.relatedId] = e;
        this.selectedArr.push(e);
      }
    },
    selectRemove: function (e) {
      var vues = this;
      this.selectedArr.forEach((item, inx) => {
        if (item.relatedId == e.relatedId) {
          vues.selectedArr.splice(inx, 1);
          delete vues.selectedMap[e.relatedId];
          return;
        }
      })
    },
    saveReturn: function () {
      var vues = this;
      return new Promise((reslove, reject) => {
        vues.$refs.ruleForm.validate((valid) => {
          if (valid) {
            reslove({
              pms1: vues.params,
              pms3: vues.selectedArr
            });
          } else {
            reslove(false);
          }
        })
      })
    }
  },
  created: function () {
    var querys = this.$route.query;
    var vues = this;



    this.pocSeek();
    if (querys.id) {

      var promiseArr = [];

      promiseArr.push(new Promise((resolve, reject) => {
        pocPredat({ id: querys.id }).then(res => {
          var unFromate = res.declarationPolicy;
          for (var key in vues.params) {
            vues.params[key] = unFromate[key];
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      }))

      promiseArr.push(new Promise((resolve, reject) => {            //  关联政策初始化
        pocReltGet({ cqjSbzcDeclarationPolicyId: querys.id }).then(res => {
          vues.selectedArr = res.relatedList;
          res.relatedList.forEach((item, i) => {
            vues.selectedMap[item.relatedId] = item;
          })
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      }))

      Promise.all(promiseArr).then(res => {
        vues.$emit('inited');
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-block {
  font-size: 15px;
  margin-bottom: 20px;
  .bName {
    width: 60px;
    float: left;
    margin-top: 9px;
  }
  .bContent {
    margin-left: 76px;
    position: relative;
  }
}

.title-block {
  width: 32%;
}

.poc-block {
  width: 32%;
  margin-top: 30px;
}

.selects {
  border-bottom: 1px solid #f5f5f5;
  .select-line {
    position: relative;
    margin-bottom: 20px;
    .selectGp {
      display: inline-block;
      width: 32%;
      span {
        font-size: 15px;
        margin-right: 12px;
      }
    }
  }
}

.img-block {
  margin-top: 30px;
}

.enclosure {
  margin-top: 60px;
  .ttl {
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent {
    margin-left: 75px;
    .uphead {
      .btn {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        font-size: 14px;
        background: rgb(86, 119, 252);
        color: white;
        cursor: pointer;
      }
      .tips {
        font-size: 13px;
        color: #999999;
        margin-left: 6px;
      }
    }
    .upList {
      .file {
        height: 32px;
        line-height: 32px;
        margin-top: 12px;
        span {
          font-size: 13px;
        }
        .btn {
          color: rgb(86, 119, 252);
          cursor: pointer;
          margin-left: 9px;
        }
      }
    }
  }
}

.pocRelative {
  width: 80%;
  background: salmon;
  margin-left: 76px;
}
</style>

<style lang="css">
.subpage.policies1 .el-input__inner {
  border-radius: 0px !important;
}

.subpage.policies1 .selects .el-input {
  width: 240px !important;
}

.subpage.policies1 .el-form-item {
  display: inline-block !important;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// Subpage1.vue?21ca7b64